import { gsap } from 'gsap';
function Animate(Sprite, { duration = 3, ScalingFactor = 1.02, ease = 'linear' }) {
  var actualwidth = Sprite.width;
  Sprite.scale.x = Sprite.scale.x * ScalingFactor;
  Sprite.scale.y = Sprite.scale.y * ScalingFactor;
  let initialx = Sprite.x;
  Sprite.x = actualwidth - Sprite.width + initialx;
  var animation = gsap.to(Sprite, { pixi: { x: initialx }, duration: duration, ease: ease, paused: true });
  return animation;
}
export default { Animate };
